import React, { useContext } from 'react';
import classNames from 'classnames';
import { ConfigContext } from '../config-provider/config-context';
import { getPrefixCls } from '../_utils/general';
import { ColProps, ColSize } from './types';

const ScreenTypes = ['xs', 'sm', 'md', 'lg', 'xl', 'xxl'];

const Col = React.forwardRef<HTMLDivElement, ColProps>((props, ref) => {
  const {
    span = 24,
    offset = 0,
    order = 0,
    prefixCls: customisedCls,
    className,
    style,
    children,
    ...otherProps
  } = props;
  const configContext = useContext(ConfigContext);
  const prefixCls = getPrefixCls('col', configContext.prefixCls, customisedCls);

  let sizeClassObj = {};
  ScreenTypes.forEach((size) => {
    let sizeProps: ColSize = {};
    // Prevent the error that expression of type 'string' can't be used to index type 'ColProps'.
    const propSize = (props as any)[size];
    if (typeof propSize === 'number') {
      sizeProps.span = propSize;
    } else if (typeof propSize === 'object') {
      sizeProps = propSize || {};
    }
    sizeClassObj = {
      ...sizeClassObj,
      [`${prefixCls}-${size}-${sizeProps.span}`]: sizeProps.span !== undefined,
      [`${prefixCls}-${size}-order-${sizeProps.order}`]: sizeProps.order || sizeProps.order === 0,
      [`${prefixCls}-${size}-offset-${sizeProps.offset}`]:
        sizeProps.offset || sizeProps.offset === 0,
    };
  });
  const cls = classNames(
    prefixCls,
    className,
    {
      [`${prefixCls}-${span}`]: span,
      [`${prefixCls}-offset-${offset}`]: offset,
      [`${prefixCls}-order-${order}`]: order,
    },
    sizeClassObj
  );

  return (
    <div {...otherProps} ref={ref} className={cls} style={style}>
      {children}
    </div>
  );
});

Col.displayName = 'Col';

export default Col;
